import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';
import { useText } from 'common/hooks';
import { ICON } from 'resources/constants';

import {
  Modal,
  CloseIconContainer,
  CloseIcon,
  InnerWrapper,
  Icon,
  Heading,
  ContentWrapper,
  ContentHeader,
  ContentText,
  Footer,
} from './elements';

const deps = {
  indicator: state.challenge.campaign.indicator,
  closeModalClicked: sequences`appContainer.closeModalClicked`,
};

export function LeaderboardModal({
  indicator,
  closeModalClicked,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  return (
    <Modal onHide={() => closeModalClicked()} show>
      <CloseIconContainer>
        <CloseIcon icon={ICON.close} onClick={() => closeModalClicked()} />
      </CloseIconContainer>
      <InnerWrapper>
        <Icon icon={ICON.leaderboard} />
        <Heading>{t(`challenge.GMod16.leaderboard_info`)}</Heading>
        {indicator === 'co2' && (
          <ContentWrapper>
            <ContentHeader>{t(`challenge.GMod16.co2_per_team`)}</ContentHeader>
            <ContentText>{t(`challenge.GMod16.shows_average_co2`)}</ContentText>
          </ContentWrapper>
        )}
        <ContentWrapper>
          <ContentHeader>{t(`challenge.GMod16.points_per_team`)}</ContentHeader>
          <ContentText>
            {t(`challenge.GMod16.shows_average_points`)}
          </ContentText>
        </ContentWrapper>
        <ContentWrapper>
          <ContentHeader>
            {t(`challenge.GMod16.participation_per_team`)}
          </ContentHeader>
          <ContentText>
            {t(`challenge.GMod16.shows_percentage_participating`)}
          </ContentText>
        </ContentWrapper>
      </InnerWrapper>
      <Footer
        onClick={() => closeModalClicked()}
        text={t('challenge.GMod16.close')}
      />
    </Modal>
  );
}

export default connect(deps, LeaderboardModal);
